import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

export const Addresses = new Mongo.Collection('addresses');

Addresses.allow({
    insert() { return true; },
    update() { return true; },
    remove() { return true; },
});

export const Address = new SimpleSchema({
    civility: {
        type: String,
        label: "Civilité",
    },
    name: {
        type: String,
        label: "Nom / Prénom",
    },
    street: {
        type: String,
        label: "N° / Voie",
    },
    city: {
        type: String,
        label: "Code Postal / Ville",
    },
    phone: {
        type: String,
        label: "Téléphone",
        optional: true
    },
  	email: {
  		type: String,
  		label: "Email",
  		optional: true
  	},  
    createdAt: {
        type: Date,
        label: "Date de création",
        optional: true
    },
    updatedAt: {
        type: Date,
        label: "Dernière mise à jour",
        optional: true
    }
});

Addresses.attachSchema(Address);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/reservations/addresses.js
 **/